import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface ArchivedFilters {
    'filter.individual'?: string;
    'filter.group'?: string;
    limit?: number;
}

type ReturnType = Promise<AxiosResponse<{ data: any[]; links: any; meta: any }>>;

const getArchivedTrackEvents = (filters: ArchivedFilters = {}): ReturnType => {
    return Request.get('/workouts/track-events/archived', {
        params: filters,
    });
};

export default getArchivedTrackEvents;
